import { bus_loaidiemdon } from '../../models/response/bus/bus_loaidiemdon';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_LOAIDIEMDON_PATH = "bus/loai-diem-don";

class BusLoaiDiemDonApi extends BaseCRUDApi<bus_loaidiemdon> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busLoaiDiemDonApi = new BusLoaiDiemDonApi(API_BUS_LOAIDIEMDON_PATH);
